import React from "react";
import { isEmpty } from "lodash";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// types
import { TMainPageLayoutV2 } from "../type";
// enums
import EContentType from "@/cms/enums/EContentType";
import EResourceType from "@/cms/enums/EResourceType";
// types
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion
} from "@/utilities/LanguageVersionSelectorShortcut";
import PencilShape01 from "@/components/shapes/PencilShape01";
import ZebraShape01 from "@/components/shapes/ZebraShape01";
import RMDRLink from "@/components/RMDRLink";


const RenderItems = (props:{ payload?:TClientMenuItemList[]|TClientMainPageItemList[]|null, languageVersionSelector:any, template?:TClientMainPageItemList }) => {
    console.log("MNPG021.RenderItems", props);

    if ( !isEmpty(props.payload) && props.payload ) {
        return (
            <>
                {
                    props.payload?.map((item, index) => {
                        const languageVersion = props.languageVersionSelector(item.languageVersions);

                        return (
                            <div
                                className="col-xl-6 col-md-6 "
                                data-aos-duration="800"
                                data-aos="fade-up"
                                data-aos-delay={`${300+(index*100)}`}
                            >
                                <div className="icon-items">
                                    <div className="icon box-color-1">
                                        <RMDRLink
                                            title={languageVersion?.name}
                                            hasNavigationDestination={item?.hasDestinationNavigation}
                                            navigationURL={languageVersion?.contentRouteNavigationURL}
                                            redirectType={item?.redirectType}
                                            isShowAlways={true}
                                        >
                                            <RMDRImage 
                                                resources={item?.resources}
                                                resourceType={EResourceType.ICON}
                                                alt={languageVersion?.name}
                                                title={languageVersion?.name}
                                            />
                                        </RMDRLink>
                                    </div>
                                    <div className="content">
                                        <h4>
                                            <RMDRLink
                                                text={languageVersion?.name}
                                                title={languageVersion?.name}
                                                hasNavigationDestination={item?.hasDestinationNavigation}
                                                navigationURL={languageVersion?.contentRouteNavigationURL}
                                                redirectType={item?.redirectType}
                                                isShowAlways={true}
                                            />
                                        </h4>
                                        <RMDRComponentSanitizer languageVersion={languageVersion} valueExpr="value" variant="p" className="tw-h-[84px] tw-line-clamp-3" removeTag />
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
            </>
        )
    }

    return null;

}

const Render = (props:TMainPageLayoutV2) => {
    console.log("MNPG021.Render", props);

    const childs = props.templates?.filter((item) => item.mapLayoutName === props.template?.mapLayoutName && ![EContentType.MAP,EContentType.SITE_SETTING].includes(item?.contentType as number) && item.parentId === props.template?.id);
    
    if ( !childs || isEmpty(childs) ) return null;
    return (<RenderItems payload={childs} languageVersionSelector={mainPageItemNameDescriptionLanguageVersion} />)
}

const MNPG021 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG021.rendered", props);

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template?.languageVersions);

    return (
        <section className="section section-padding">
            <PencilShape01 />
            <ZebraShape01 className="float-bob-y" />
            <div className="container">
                <div className="about-activities-wrapper">
                    <div className="row g-4">
                        <div
                            className="col-xl-6 "
                            data-aos-duration="800"
                            data-aos="fade-up"
                            data-aos-delay="400"
                        >
                            <div className="activities-image">
                                <RMDRImage 
                                    title={languageVersion?.name}
                                    alt={languageVersion?.name}
                                    resources={props.template.resources}
                                    resourceType={EResourceType.OUTER_IMAGE}
                                />
                            </div>
                        </div>
                        <div className="col-xl-6">
                            <div className="activities-content">
                                <div className="section-title">
                                    <h2
                                        data-aos-duration="800"
                                        data-aos="fade-up"
                                        data-aos-delay="300"
                                    >
                                        {languageVersion?.name}
                                    </h2>
                                </div>
                                <RMDRComponentSanitizer
                                    languageVersion={languageVersion}
                                    className="mt-3 mt-md-0 section-content"
                                    extraData={{
                                        "data-aos-duration": "800",
                                        "data-aos": "fade-up",
                                        "data-aos-delay": "500"
                                    }}
                                    removeTag
                                    valueExpr="value"
                                    variant="div"
                                />
                                <div className="row g-4 mt-4">
                                    <Render {...props} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

const Component = React.memo(MNPG021, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG021.memo", { prevProps, nextProps });
    return true;
});

export default Component;
